import React, { useEffect, useState } from 'react';
import { Checkbox, Modal, message } from 'antd';
import { theme } from 'utils/style/theme';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import iconClose from 'utils/icon/icon_close_circle.svg';
import { showApiErrorMessage } from 'utils/helper/message';
import PrimaryButton from 'components/button/PrimaryButton';

import { costumeApis } from 'apis/resource/costumeApis';
import SelectBox from 'components/SelectBox';
import InputStyled from 'components/InputStyled';
import { ICommonCode, IDressCreate } from 'utils/types/storyTypes';

/**
 * * 리소스 - 미니컷 등록 모달
 */

interface IProps {
  visible: {
    register: boolean;
    delete: boolean;
    update: boolean;
    name: string;
  };
  setVisible: (e: any) => void;
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
  refresh: boolean;
  projectId: string | undefined;
  profileList: ICommonCode[] | null;
}

const CostumeCreateModal = ({
  visible,
  setVisible,
  setRefresh,
  refresh,
  projectId,
  profileList,
}: IProps) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState<string>(''); // dress name input
  const [profileValue, setProfileValue] = useState<string>(''); // 프로필 드롭다운 값
  const [defaultDressValue, setDefaultDressValue] = useState<boolean>(false);

  useEffect(() => {
    console.log(`CostumeCreateModal profileList : `, profileList);

    if (profileList && profileList.length > 0) {
      setProfileValue(profileList[0].code);
    }
  }, []);

  const [loading, setLoading] = useState(false);

  /// 서버 전송
  const handleSubmit = async () => {
    if (projectId) {
      try {
        const updateData: IDressCreate = {
          dress_name: inputValue,
          project_id: Number(projectId),
          speaker: profileValue,
          is_default: defaultDressValue,
        };

        const postData = {
          update: updateData,
        };

        setLoading(true);

        console.log(`costumeCreate start`);
        const result = await costumeApis.costumeCreate(projectId, postData);

        console.log(`costumeCreate done`);

        setRefresh(!refresh);
        setLoading(false);
        handleClose();
      } catch (err) {
        setLoading(false);
        showApiErrorMessage(err);
      }
    }
  };

  /// 모달 닫기
  const handleClose = () => {
    setVisible({ ...visible, register: false });
    setInputValue('');
    // 폼을 비워줘야 이미지 첨부한 것도 비워진다.
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleOnChangeSelect = (e) => {
    // setCreateData({ ...createData, [`${type}`]: value });
    // ? 이거는 바로 value가 오네???
    console.log(`handleOnChangeSelect: `, e);
    setProfileValue(e);
  };

  return (
    <CustomModal
      title={t(
        'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.costumeContent.createModal.title',
      )}
      open={visible.register}
      onCancel={handleClose}
      footer={
        <ButtonWrapper>
          <PrimaryButton
            text={t(
              'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.costumeContent.createModal.button',
            )}
            height='40px'
            width='fit-content'
            bgColor={theme.colors.blue_500}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.blue_500}`}
            rounded='6px'
            hoverBgColor={theme.colors.blue_600}
            activeBgColor={theme.colors.blue_800}
            selectedBgColor={theme.colors.blue_700}
            onClick={handleSubmit}
            loading={loading}
            disabled={loading}
          />
        </ButtonWrapper>
      }
      closeIcon={
        <img src={iconClose} width={20} height={20} alt='icon-close' />
      }
    >
      <SectionWarpper>
        <div>
          <p className='title'>
            {t(
              'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.costumeContent.createModal.name',
            )}
          </p>
          <InputStyled
            value={inputValue}
            onChange={(e) => {
              handleInputChange(e);
            }}
            maxLength={30}
            placeholder='스크립트에서 사용할 의상이름을 기입합니다.'
          />
          <p className='length-subtext'>
            {typeof inputValue.length === 'number'
              ? `${inputValue.length}/30 characters`
              : '0/30 characters'}
          </p>
        </div>
        <div>
          <p className='title'>
            {t(
              'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.costumeContent.createModal.character',
            )}
          </p>
          <SelectBox
            value={profileValue}
            onChange={(e) => {
              handleOnChangeSelect(e);
            }}
            options={profileList?.map((v, i) => {
              return {
                value: v.code,
                label: v.code_name,
              };
            })}
          />
        </div>
        <CheckboxWrapper>
          <p>
            {t(
              'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.costumeContent.createModal.default',
            )}
            :
          </p>
          <Checkbox
            checked={defaultDressValue}
            onChange={(e) => {
              setDefaultDressValue(e.target.checked);
            }}
          />
        </CheckboxWrapper>
        <p className='length-subtext'>
          ** 스크립트에서 의상을 지정하지 않으면 기본의상 체크된 의상을 입고
          등장합니다.
        </p>
      </SectionWarpper>
    </CustomModal>
  );
};

export default CostumeCreateModal;

const CustomModal = styled(Modal)`
  .ant-modal-body {
    padding: 0;
  }
  .ant-modal-content {
    box-shadow: none;
    width: 566px;
  }
  .ant-radio-wrapper {
    span {
      font-size: ${theme.fontSizes.normal};
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.2px;
      color: ${theme.colors.dark_500};
    }
  }
  .ant-modal-footer {
    margin-top: 10px !important;
  }
  ul {
    margin-left: 25px;
  }
  .ant-modal-close:hover {
    background-color: transparent;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;

const SectionWarpper = styled.div`
  & > * + * {
    margin-top: 8px;
  }
  .title,
  .length-subtext {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
  }
`;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  & > * + * {
    margin-left: 1rem;
  }
`;
